export const REVEAL_PROCUREMENT_LIST = { revealProcurementList: true } as const;

export const asksToRevealProcurementList = (state: unknown): boolean =>
  typeof state === "object" && state != null && (state as Record<string, unknown>).revealProcurementList === true;
